"use client"

import { ProgressProvider as BProgressProvider } from "@bprogress/next/app"

import type { ReactNode } from "react"

/**
 * Thin top progress bar on client navigation (perceived speed). Wraps
 * `@bprogress/next`'s App Router provider in a client boundary — the package
 * doesn't ship a "use client" directive, so importing it directly into the
 * server `Providers` tree pulls `createContext` into the server graph and breaks
 * the build. Anchor-driven and independent of MSAL: it tracks App Router route
 * changes, never the AuthGate's sign-in redirect.
 */
export function ProgressProvider({ children }: { children: ReactNode }) {
  return (
    <BProgressProvider
      height="2px"
      color="hsl(var(--primary))"
      options={{ showSpinner: false }}
      shallowRouting
      disableSameURL
    >
      {children}
    </BProgressProvider>
  )
}
